import 'css-chunksrc/feature/provision/ProvisionItemList.module.scss';export default {
  "list": "ProvisionItemList_list"
};